export const MANAGEMENT_SIGNALS_API_INTEGRATION_STATUS_QUERY_KEY = "management:signals-api-integration-status";

export const POLLING_INTERVAL = 10000;
